import React from 'react';
import './PageLayout.css';
import Footer from '../components/Footer';

function HowToPlay() {
  const highContrastEnabled = window.localStorage.getItem('highContrastEnabled') === 'true';
  const hitSquare = highContrastEnabled ? '🟧' : '🟩';
  const partialSquare = highContrastEnabled ? '🟦' : '🟨';
  const hitColorName = highContrastEnabled ? 'Orange' : 'Green';
  const partialColorName = highContrastEnabled ? 'Blue' : 'Yellow';

  return (
    <div className="page-layout">
      <header className="page-header">
        <a href="/" className="page-back-link">← Back to Don't Wordle</a>
      </header>
      <main className="page-content">
        <h1>How to Play</h1>
        <div className="page-body">
          <p>Don't Wordle is just like <a href="https://www.nytimes.com/games/wordle/index.html" target="_blank" rel="noopener noreferrer">Wordle</a> but the opposite.</p>
          <p>In Wordle, the goal is to guess a particular 5 letter word in 6 or fewer tries. In Don't Wordle, the goal is to <strong>NOT</strong> guess the word.</p>
          <p>The catch is that your word attempts must respect the information you have learned in previous guesses.</p>
          <ol>
            <li><strong>{hitSquare} {hitColorName}</strong> — Once you place a letter correctly, future guesses must contain that same letter in the same position.</li>
            <li><strong>{partialSquare} {partialColorName}</strong> — Once you place a correct letter in an incorrect location, future guesses must contain that letter in a different location.</li>
            <li><strong>⬜ Gray</strong> — Once letters have been guessed and eliminated, you can no longer use them.</li>
          </ol>
          <p>The number of valid words remaining appears at the top, and it will shrink with each guess. If the number gets too low, you can use one of your "UNDOs" to reverse course.</p>
          <p>Be careful! If you accidentally enter the Wordle word, the game is over even if you have some UNDOs remaining.</p>
          <p>
            <a href="/">Play Don't Wordle</a>
            {' · '}
            <a href="/tips">Tips</a>
            {' · '}
            <a href="/faq">FAQ</a>
          </p>
        </div>
      </main>
      <div className="page-footer-slot">
        <Footer />
      </div>
    </div>
  );
}

export default HowToPlay;
